import React, { createContext, useContext, useEffect, useState } from "react";
import client, { apiError } from "@/api/client";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const ROLE_LABELS = {
  super_admin: "Pemilik",
  admin: "Regional Manager",
  branch_head: "Kepala Cabang",
  cashier: "Kasir",
  warehouse: "Gudang",
  reseller: "Mitra Siap Saji",
  financial: "Pelaporan Keuangan",
};

export const ALL_BRANCH_ROLES = ["super_admin", "admin", "financial"];

// Landing setelah login — Pemilik/Admin/Kepala Cabang ke Dashboard, Kasir ke POS.
// Gudang & Mitra ke halaman fungsinya (tidak punya akses Dashboard).
export function landingPath(role) {
  if (role === "cashier") return "/pos";
  if (role === "warehouse") return "/stok";
  if (role === "reseller") return "/pesanan";
  return "/dashboard";
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=not auth

  useEffect(() => {
    const t = localStorage.getItem("tokoku_token");
    if (!t) {
      setUser(null);
      return;
    }
    client
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("tokoku_token");
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await client.post("/auth/login", { email, password });
      localStorage.setItem("tokoku_token", data.access_token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: apiError(e) };
    }
  };

  const logout = () => {
    localStorage.removeItem("tokoku_token");
    setUser(null);
  };

  const isAllBranch = user && ALL_BRANCH_ROLES.includes(user.role);

  return (
    <AuthContext.Provider value={{ user, login, logout, isAllBranch }}>
      {children}
    </AuthContext.Provider>
  );
}
